<template>
  <div>
    {{ t('NOT FOUND') }}
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@/composables';

const { t } = useI18n();
</script>
